import { useIntl } from 'react-intl'

import SupportTile from 'components/Common/SupportTile/SupportTile'
import LayoutContainer from 'components/Common/LayoutContainer'

function CruisePageSupportSection() {
  const intl = useIntl()

  return (
    <LayoutContainer>
      <SupportTile description={intl.formatMessage({
        id: 'pFOvv6ZwcPPByHe9mCHO',
        defaultMessage: 'Call our dedicated customer service team anytime.',
        description: 'Support tile description on cruises page in the cruise section',
      })}
      />
    </LayoutContainer>
  )
}

export default CruisePageSupportSection
